import { useEffect, useState } from 'react'

import { TPageContentProps } from '@/config/types'

import { ReviewTypeF } from '@/components/review'

export const PreparingPlanType5 = ({ reviewsTitle, reviews, goToNextPage }: TPageContentProps) => {
  const animationDuration = 12 * 970
  const [counter, setCounter] = useState<number>(0)

  useEffect(() => {
    const textIntervalId = setInterval(() => {
      if (counter <= 100) {
        setCounter((prevState) => prevState + 1)
      }
    }, animationDuration / 100)

    if (counter >= 100) {
      clearInterval(textIntervalId)
      goToNextPage()
    }
    return () => {
      clearInterval(textIntervalId)
    }
  }, [animationDuration, counter, goToNextPage])
  return (
    <div>
      <div className="svg-container">
        <svg width="200px" height="200px" viewBox="0 0 38 38">
          <circle
            cx="19"
            cy="19"
            r="15.91549430918954"
            fill="transparent"
            strokeWidth="3"
            id="donut-ring"
          />

          <circle
            cx="19"
            cy="19"
            r="15.91549430918954"
            fill="transparent"
            strokeWidth="3"
            strokeDasharray="100 0"
            strokeDashoffset="25"
            strokeLinecap="round"
            id="donut-hole"
          />

          <image
            href="data:image/png;base64,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"
            x="15.85"
            y="14.25"
            width="6.3"
            height="9.5"
          />
        </svg>
      </div>
      <ReviewTypeF reviewsTitle={reviewsTitle} reviews={reviews || []} />
    </div>
  )
}
